import * as apiUrl from "../../apiUrl";



export const fetchAboutPageData = async () => {
  try {
    const endpoints = [
      "/api/about/banner-section",
      "/api/about/invest-section",
      "/api/about/amenities-section",
      "/api/about/our-identity-section",
      "/api/about/why-section",
      "/api/about/mission-vision-section",
      "/api/about/last-image-section",
    ];

    const fetchPromises = endpoints.map(async (endpoint) => {
      const url = apiUrl.apiUrl + endpoint;
      const response = await fetch(url);
      if (!response.ok) {
        console.error(`Failed to fetch ${url}: Status ${response.status}`);
        throw new Error(`HTTP error ${response.status}`);
      }
      return response.json();
    });

    const [
      banner,
      investing,
      amenities,
      identity,
      whyMarquis,
      visionMission,
      parallax,
    ] = await Promise.all(fetchPromises);

    return { banner, investing, amenities, identity, whyMarquis, visionMission, parallax };
  } catch (error) {
    console.error("Error fetching about page data:", error);
    return null;
  }
};


export const fetchAboutPageData123 = async () => {
  try {
    const [bannerResponse, investingResponse, amenitiesResponse, identityResponse, whyMarquisResponse, visionMissionResponse, parallaxResponse] = await Promise.all([
      fetch(apiUrl.apiUrl + "/api/about/banner-section"),
      fetch(apiUrl.apiUrl + "/api/about/invest-section"),
      fetch(apiUrl.apiUrl + "/api/about/amenities-section"),
      fetch(apiUrl.apiUrl + "/api/about/our-identity-section"),
      fetch(apiUrl.apiUrl + "/api/about/why-section"),
      fetch(apiUrl.apiUrl + "/api/about/mission-vision-section"),
      fetch(apiUrl.apiUrl + "/api/about/last-image-section"),
    ]);

    if (
      !bannerResponse.ok ||
      !investingResponse.ok ||
      !amenitiesResponse.ok ||
      !identityResponse.ok ||
      !whyMarquisResponse.ok ||
      !visionMissionResponse.ok ||
      !parallaxResponse.ok
    ) {
      throw new Error("Failed to fetch one or more sections");
    }

    return {
      banner: await bannerResponse.json(),
      investing: await investingResponse.json(),
      amenities: await amenitiesResponse.json(),
      identity: await identityResponse.json(),
      whyMarquis: await whyMarquisResponse.json(),
      visionMission: await visionMissionResponse.json(),
      parallax: await parallaxResponse.json(),
    };
  } catch (error) {
    console.error("Error fetching about page data:", error);
    return null;
  }
};
